import React from 'react';
import styled from 'styled-components';

const SkillSort = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  line-height: 1;
  padding: 0;
  margin: 0 0 10px;

  @media screen and (max-width: 600px) {
    justify-content: center;
  }

  label {
    font-weight: 700;
    margin-right: 10px;
  }
`;

const SkillSorter = styled.li`
  color: ${props => (props.sorter === props.sort ? '#14acd0' : 'inherit')};
  font-weight: ${props => (props.sorter === props.sort ? '700' : '300')};
  cursor: pointer;
  margin-right: 8px;
  list-style-type: none;

  &:last-child {
    margin: 0;
  }
`;

export default props => (
  <SkillSort>
    <label>Sort By:</label>
    <SkillSorter sorter="title" sort={props.sort} onClick={() => props.setSort('title')}>
      Title
    </SkillSorter>
    <SkillSorter sorter="rating" sort={props.sort} onClick={() => props.setSort('rating')}>
      Knowledge
    </SkillSorter>
  </SkillSort>
);



// WEBPACK FOOTER //
// ./src/components/Skill/SkillSort.js